import axios from 'axios'

const api = axios.create({
    baseURL: 'https://gsehelp.com/api',
});
  

export default api;

